import api from 'api/apiInstance';

export function clientResendApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
